/* =============================================
   CASE UP THEME — theme.js
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ─── NAV DRAWER (sidebar navigation, opened via menu icon) ───
  const navDrawer = document.getElementById('NavDrawer');
  const navMenuToggle = document.getElementById('NavMenuToggle');
  const navDrawerClose = document.getElementById('NavDrawerClose');
  const navDrawerBackdrop = document.getElementById('NavDrawerBackdrop');

  function openNavDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.add('open');
    if (navDrawerBackdrop) navDrawerBackdrop.hidden = false;
    if (navMenuToggle) navMenuToggle.setAttribute('aria-expanded', 'true');
    navDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeNavDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.remove('open');
    if (navDrawerBackdrop) navDrawerBackdrop.hidden = true;
    if (navMenuToggle) navMenuToggle.setAttribute('aria-expanded', 'false');
    navDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (navMenuToggle) navMenuToggle.addEventListener('click', openNavDrawer);
  if (navDrawerClose) navDrawerClose.addEventListener('click', closeNavDrawer);
  if (navDrawerBackdrop) navDrawerBackdrop.addEventListener('click', closeNavDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && navDrawer && navDrawer.classList.contains('open')) {
      closeNavDrawer();
    }
  });

  // ─── QUICK ADD TO CART ───
  document.querySelectorAll('.product-add-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.getAttribute('data-product-id');
      if (!variantId) return;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.classList.add('added');
        btn.textContent = '✓';
        setTimeout(function () {
          btn.classList.remove('added');
          btn.textContent = '+';
        }, 1800);
        updateCartCount();
      })
      .catch(function (err) { console.error('Add to cart error:', err); });
    });
  });

  // ─── COLLECTION SIDEBAR: MOBILE DRAWER ───
  const sidebar = document.getElementById('CollectionSidebar');
  const filterToggle = document.getElementById('FilterToggleMobile');
  const sidebarClose = document.getElementById('SidebarClose');
  const sidebarBackdrop = document.getElementById('SidebarBackdrop');

  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('open');
    if (sidebarBackdrop) sidebarBackdrop.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('open');
    if (sidebarBackdrop) sidebarBackdrop.hidden = true;
    document.body.style.overflow = '';
  }
  if (filterToggle) filterToggle.addEventListener('click', openSidebar);
  if (sidebarClose) sidebarClose.addEventListener('click', closeSidebar);
  if (sidebarBackdrop) sidebarBackdrop.addEventListener('click', closeSidebar);

  // ─── COLLECTION FILTERS: AUTO-SUBMIT ON CHECKBOX CHANGE ───
  const facetForm = document.getElementById('FacetFiltersForm');
  if (facetForm) {
    facetForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        facetForm.submit();
      });
    });
  }

  // ─── UPDATE CART COUNT IN HEADER ───
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const badge = document.querySelector('.cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        }
      });
  }

  // ─── PRODUCT GALLERY THUMBNAILS (hidden, used as data source) ───
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      const newSrc = thumb.getAttribute('data-image');
      const mainImg = document.getElementById('ProductFeaturedImage');
      if (mainImg && newSrc) mainImg.src = newSrc;
    });
  });

  // ─── PRODUCT GALLERY ARROWS (cycle through the same images) ───
  const galleryThumbs = document.querySelectorAll('.product-thumb');
  const galleryPrev = document.getElementById('GalleryPrev');
  const galleryNext = document.getElementById('GalleryNext');
  if (galleryThumbs.length > 1 && galleryPrev && galleryNext) {
    const galleryImages = Array.from(galleryThumbs).map(function (t) { return t.getAttribute('data-image'); });
    let galleryIndex = 0;
    const mainImg = document.getElementById('ProductFeaturedImage');
    function showGalleryImage(index) {
      galleryIndex = (index + galleryImages.length) % galleryImages.length;
      if (mainImg) mainImg.src = galleryImages[galleryIndex];
      galleryThumbs.forEach(function (t, i) { t.classList.toggle('active', i === galleryIndex); });
    }
    galleryPrev.addEventListener('click', function () { showGalleryImage(galleryIndex - 1); });
    galleryNext.addEventListener('click', function () { showGalleryImage(galleryIndex + 1); });
  }

  // ─── PRODUCT QUANTITY BUTTONS (product page) ───
  const productQtyInput = document.getElementById('ProductQuantity');
  const productDecreaseBtn = document.querySelector('[data-qty-decrease]');
  const productIncreaseBtn = document.querySelector('[data-qty-increase]');
  if (productQtyInput && productDecreaseBtn && productIncreaseBtn) {
    productDecreaseBtn.addEventListener('click', function () {
      const val = Math.max(1, parseInt(productQtyInput.value || '1', 10) - 1);
      productQtyInput.value = val;
    });
    productIncreaseBtn.addEventListener('click', function () {
      const val = parseInt(productQtyInput.value || '1', 10) + 1;
      productQtyInput.value = val;
    });
  }

  // ─── VARIANT OPTION PILLS / SWATCHES ───
  const variantSelect = document.getElementById('ProductSelectVariant');
  const optionGroups = document.querySelectorAll('.product-option-values');

  function updateProductFromVariant(optionEl) {
    if (!optionEl) return;

    const price = optionEl.getAttribute('data-price');
    const comparePrice = optionEl.getAttribute('data-compare-price');
    const priceRaw = parseInt(optionEl.getAttribute('data-price-raw') || '0', 10);
    const compareRaw = parseInt(optionEl.getAttribute('data-compare-raw') || '0', 10);
    const image = optionEl.getAttribute('data-image');
    const available = !optionEl.disabled;

    const priceWrap = document.getElementById('ProductPrice');
    if (priceWrap && price) {
      if (compareRaw > priceRaw) {
        priceWrap.innerHTML =
          '<span class="product-price-current product-price--sale">' + price + '</span>' +
          '<span class="product-price-compare">' + comparePrice + '</span>';
      } else {
        priceWrap.innerHTML = '<span class="product-price-current">' + price + '</span>';
      }
    }

    if (image) {
      const mainImg = document.getElementById('ProductFeaturedImage');
      if (mainImg) mainImg.src = image;
    }

    const addBtn = document.getElementById('AddToCartButton');
    const addText = document.getElementById('AddToCartText');
    if (addBtn && addText) {
      if (available) {
        addBtn.disabled = false;
        addText.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addText.textContent = 'Sold Out';
      }
    }
  }

  if (optionGroups.length && variantSelect) {
    optionGroups.forEach(function (group) {
      group.querySelectorAll('.option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('active'); });
          pill.classList.add('active');

          const optionIndex = pill.getAttribute('data-option-index');
          const value = pill.getAttribute('data-value');
          const label = document.querySelector('[data-option-value-label="' + optionIndex + '"]');
          if (label) label.textContent = value;

          // Gather currently selected values across all option groups, in order
          const selectedValues = [];
          optionGroups.forEach(function (g) {
            const active = g.querySelector('.option-pill.active');
            selectedValues.push(active ? active.getAttribute('data-value') : null);
          });

          // Find the matching variant
          let matchedOption = null;
          Array.prototype.forEach.call(variantSelect.options, function (opt) {
            const optValues = (opt.getAttribute('data-options') || '').split(',');
            const matches = selectedValues.every(function (val, i) {
              return val === null || optValues[i] === val;
            });
            if (matches) matchedOption = opt;
          });

          if (matchedOption) {
            variantSelect.value = matchedOption.value;
            updateProductFromVariant(matchedOption);
          }
        });
      });
    });
  }

  // ─── ADD TO CART (AJAX) ───
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const addBtn = document.getElementById('AddToCartButton');
      const addText = document.getElementById('AddToCartText');
      if (!addBtn || addBtn.disabled) return;

      const originalText = addText.textContent;
      addText.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(productForm)
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            addText.textContent = data.description || 'Could not add';
            setTimeout(function () { addText.textContent = originalText; }, 2200);
            return;
          }
          addBtn.classList.add('added');
          addText.textContent = 'Added ✓';
          updateCartCount();
          setTimeout(function () {
            addBtn.classList.remove('added');
            addText.textContent = originalText;
          }, 1800);
        })
        .catch(function () {
          addText.textContent = originalText;
        });
    });
  }

  // ─── CART PAGE: QUANTITY CONTROLS & REMOVE ───
  function updateCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { window.location.reload(); })
      .catch(function (err) { console.error('Cart update error:', err); });
  }

  document.querySelectorAll('[data-cart-qty-decrease], [data-cart-qty-increase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const line = btn.getAttribute('data-line');
      const input = document.querySelector('.cart-qty-input[data-line="' + line + '"]');
      if (!input) return;
      let val = parseInt(input.value || '1', 10);
      if (btn.hasAttribute('data-cart-qty-decrease')) {
        val = Math.max(0, val - 1);
      } else {
        val += 1;
      }
      input.value = val;
      updateCartLine(line, val);
    });
  });

  document.querySelectorAll('.cart-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      let val = parseInt(input.value || '0', 10);
      if (val < 0) val = 0;
      updateCartLine(input.getAttribute('data-line'), val);
    });
  });

  document.querySelectorAll('.cart-item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      updateCartLine(btn.getAttribute('data-line'), 0);
    });
  });

  // ─── SCROLL REVEAL (lightweight) ───
  if ('IntersectionObserver' in window) {
    const style = document.createElement('style');
    style.textContent = `
      .reveal { opacity: 0; transform: translateY(24px); transition: opacity 0.55s ease, transform 0.55s ease; }
      .reveal.visible { opacity: 1; transform: translateY(0); }
    `;
    document.head.appendChild(style);

    const items = document.querySelectorAll(
      '.product-card, .cat-card, .perk, .section-title'
    );
    items.forEach(function (el) { el.classList.add('reveal'); });

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach(function (el) { observer.observe(el); });
  }

});

/* ─── Custom text character counter ──────────── */
document.addEventListener('DOMContentLoaded', function() {
  var textarea = document.getElementById('CustomText');
  var counter = document.getElementById('CustomTextCount');
  if (textarea && counter) {
    textarea.addEventListener('input', function() {
      counter.textContent = this.value.length;
      var max = parseInt(this.getAttribute('maxlength'));
      counter.style.color = this.value.length >= max ? '#e63946' : '#999';
    });
  }
});
